// Form submissions go to Formspree (free tier) — no backend required.
// Create one form per type at https://formspree.io and put the IDs in .env
const ENDPOINTS = {
  volunteer: process.env.REACT_APP_FORMSPREE_VOLUNTEER,
  contact: process.env.REACT_APP_FORMSPREE_CONTACT,
  partnership: process.env.REACT_APP_FORMSPREE_PARTNERSHIP,
};

export const submitForm = async (kind, data) => {
  const endpoint = ENDPOINTS[kind];
  if (!endpoint) {
    throw new Error(
      `No Formspree endpoint configured for "${kind}". Add REACT_APP_FORMSPREE_${kind.toUpperCase()} to your environment variables.`
    );
  }
  const res = await fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ ...data, _subject: `TechTies — new ${kind} submission` }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.errors?.[0]?.message || "Submission failed. Please email us directly.");
  }
  return res.json().catch(() => ({}));
};
